import axios from "axios";

export const state = {
    creditreports: [],
};

export const getters = {
    creditreports: (state) => state.creditreports,
};

export const mutations = {
    setCreditReports(state, newValue) {
        state.creditreports = newValue;
    },
};

export const actions = {
    async fetchCreditReports({ commit }) {
        await axios.get("/credit-score-reports").then((res) => {
            commit("setCreditReports", res.data.creditreports);
        });
    },
};
